module.exports = __webpack_public_path__ + "static/media/step-3-rain.5eb40fa3.gif";